export const QL7_SUPPORT_PUBLIC_CONTACT_ACCOUNT_ID = '0x8F49b54543c77A08f38BF036F3CFe5a3D7Ef16EC'
export const QL7_SUPPORT_PUBLIC_CONTACT_PENDING_KEY = 'ql7_support_public_contact_after_forum'
export const QL7_SUPPORT_PUBLIC_CONTACT_EVENT = 'ql7-support:open-public-contact'

export async function resolveQl7SupportPublicContactAccountId({
  rawId = QL7_SUPPORT_PUBLIC_CONTACT_ACCOUNT_ID,
  fetchFn = globalThis.fetch,
} = {}) {
  const sourceId = String(rawId || '').trim()
  if (!sourceId) throw new Error('missing_public_support_contact_id')
  if (typeof fetchFn !== 'function') throw new Error('missing_fetch')

  const response = await fetchFn(
    `/api/profile/user-popover?uid=${encodeURIComponent(sourceId)}&presence=1`,
    { method: 'GET', cache: 'no-store' },
  )
  const payload = await response?.json?.().catch(() => null)
  if (!response?.ok || !payload?.ok) {
    throw new Error(String(payload?.error || `public_support_contact_http_${Number(response?.status || 0)}`))
  }

  const accountId = String(payload?.accountId || payload?.userId || '').trim()
  if (!accountId) throw new Error('missing_public_support_contact_account_id')
  return accountId
}
